import { Flex, MenuItem, Text, Tooltip } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';
import { useGlobalUI } from '@/components/GlobalUIProvider';
import UnenrollDeviceModal from '@/components/People/EmployeeProfile/UnenrollDeviceModal';
import { DeviceAsset } from '@/types/assets';

type UnenrollDeviceMenuItemProps = {
  deviceAsset: DeviceAsset;
  employeeName: string;
  /** The assignee exists but the user can't see them, so there is no name to show. */
  isAssigneeHidden?: boolean;
  isLoading: boolean;
  disabledBecause?: string;
};

const UnenrollDeviceMenuItem = ({
  deviceAsset,
  employeeName,
  isAssigneeHidden,
  isLoading,
  disabledBecause: disabledBecause,
}: UnenrollDeviceMenuItemProps) => {
  const { t } = useTranslation('assets');
  const { openModal, closeModal } = useGlobalUI();

  const handleUnenrollDevice = () => {
    if (!employeeName && !isAssigneeHidden) return;

    openModal(
      <UnenrollDeviceModal
        deviceAsset={deviceAsset}
        employeeName={employeeName}
        onCompleteUnenroll={closeModal}
        onCancel={closeModal}
      />
    );
  };

  const isDisabled = !!disabledBecause;

  return (
    <Tooltip
      maxWidth="30rem"
      content={disabledBecause}
      placement="left"
      disabled={!isDisabled}>
      <Flex width="100%">
        <MenuItem
          id="unenroll-device-menu-item"
          onClick={handleUnenrollDevice}
          disabled={isLoading || isDisabled}>
          <Text>{t('assetDetailsButtonMenu.removeElectricAppAndMDM')}</Text>
        </MenuItem>
      </Flex>
    </Tooltip>
  );
};

export default UnenrollDeviceMenuItem;
